import { Palette } from "config/palette";
import styled, { css } from "styled-components";

const headerLogoStyle = css`
    width: 70px;
    height: 70px;
    background-color: ${Palette.HeroGreen};
    margin-top: -5px;
    margin-bottom: -5px;
    margin-left: -5px;

    display: flex;
    justify-content: center;
    align-items: center;
`;

const headerTitleStyle = css`
    display: flex;
    flex: 1;
    align-items: center;
    justify-content: flex-start;
    text-align: left;
    margin-right: auto;
    margin-left: 20px;
`;

export const HeaderLogoStyle = styled.div`
    ${headerLogoStyle}
`;

export const HeaderTitleStyle = styled.div`
    ${headerTitleStyle}
`;
